import React from "react";
import PropTypes from "prop-types";
import { TableCell, TableRow } from "@mui/material";
import WorkIcon from "@mui/icons-material/Work";
import { formatDateTimeLocal } from "utils/misc";
import { toLower } from "ramda";
import useTranslate from "hooks/use-translate-language";
import OrderDetailsModal from "./order-details-modal";


const getOrderStatusColor = status => {
  const statusColor = { backgroundColor: "white", color: "black" };

  switch (toLower(status)) {
    case "pending equipment":
    case "pending shipment":
    case "pending":
    case "pending buildout":
    case "pending fulfillment":
    case "coach follow up":
    case "incorrect":
    case "location assistance needed":
    case "ready for review":
    case "internal processing":
    case "ivr pending work":
      statusColor.backgroundColor = "rgb(245, 143, 8)"; 
      break;
    case "new":
    case "accepted":
      statusColor.backgroundColor = "#05294A"; // Primary
      statusColor.color = "white";
      break;
    case "rejected":
    case "voided":
    case "on hold":
    case "backordered":
      statusColor.backgroundColor = "rgb(174, 22, 62)";
      statusColor.color = "white";
      break;
    case "completed":
      statusColor.backgroundColor = "rgb(0, 92, 31)"; 
      statusColor.color = "white";
      break;
    default:
      statusColor.backgroundColor = "rgb(245, 143, 8)"; 
  }

  return statusColor;
};

const OrderRow = ({ order }) => {
  const translate = useTranslate();

  return (
    <TableRow
      sx={{
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)"
        }
      }}
    >
      <TableCell aria-labelledby="items-requested-header">

        <div className="order-items-cell">
          <WorkIcon sx={{ color: "#9E9E9E" }} aria-hidden="true" />
          <div className="order-items-text-container">
            <span>
              {order.requested_equipment.map(x => translate(x)).join(", ")}
            </span>
            <span className="order-items-text-date">
              {formatDateTimeLocal(order.order_date)}
            </span>
          </div>
        </div>
      </TableCell>

      <TableCell
        style={{ paddingLeft: "0", paddingRight: "0" }}
        aria-labelledby="status-header"
      >
        <span
          className="status-info"
          style={getOrderStatusColor(order.status)}
        >
          {translate(toLower(order.status))}
        </span>
      </TableCell>
      <TableCell aria-labelledby="details-header">
        <OrderDetailsModal orderId={order._id} mobileCard={false} />
      </TableCell>
    </TableRow>
  );
};

OrderRow.propTypes = {
  order: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    order_date: PropTypes.string.isRequired,
    requested_equipment: PropTypes.arrayOf(PropTypes.string).isRequired,
    status: PropTypes.string.isRequired
  }).isRequired
};

export default OrderRow;

